<template>
    <div>
        <v-row class="mb-7">
            <v-col cols="3">
                <v-speed-dial
                    v-model="fab"
                    :direction="direction"
                    transition="slide-y-reverse-transition"
                >
                    <template v-slot:activator>
                        <v-btn
                            v-model="fab"
                            color="white"
                            dark
                            small
                            fab
                            @click="btn_reset()"
                        >
                            <v-icon v-if="fab" color="blue-grey darken-1"
                                >mdi-close</v-icon
                            >
                            <v-icon v-else color="light-blue darken-4"
                                >mdi-barcode-scan</v-icon
                            >
                        </v-btn>
                    </template>
                    <v-btn
                        fab
                        dark
                        small
                        color="teal"
                        @click="change_barcode('Image')"
                    >
                        <v-icon>mdi-image</v-icon>
                    </v-btn>
                    <v-btn
                        fab
                        dark
                        small
                        color="cyan"
                        @click="change_barcode('Stream')"
                    >
                        <v-icon>mdi-barcode-scan</v-icon>
                    </v-btn>
                </v-speed-dial>
            </v-col>
            <v-col cols="9">
                <v-chip
                    small
                    v-if="data != null"
                    :color="data === 'error' ? 'red' : ''"
                    >{{ data }}</v-chip
                ></v-col
            >
        </v-row>

        <v-row v-if="Image === true">
            <v-col cols="12">
                <ImageBarcodeReader
                    @decode="onDecode"
                    @error="onError"
                ></ImageBarcodeReader>
            </v-col>
        </v-row>

        <v-row v-if="Stream === true">
            <v-col cols="12" class="mar-t-30">
                <StreamBarcodeReader
                    @decode="onDecode"
                    @loaded="onLoaded"
                ></StreamBarcodeReader>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { StreamBarcodeReader, ImageBarcodeReader } from "vue-barcode-reader"

export default {
    components: {
        StreamBarcodeReader,
        ImageBarcodeReader,
    },
    props: ["direction"],
    methods: {
        change_barcode(stataus) {
            if (stataus === "Stream") {
                if (this.StreamBarcodeReader) {
                    console.log(
                        this.StreamBarcodeReader,
                        "--StreamBarcodeReader"
                    )
                    this.StreamBarcodeReader.getTracks().forEach((track) =>
                        track.stop()
                    )
                }
                this.Stream = !this.Stream
                this.Image = false
            } else if (stataus === "Image") {
                this.Image = true
                this.Stream = false
            }
        },
        btn_reset() {
            this.data = null
            this.Stream = false
            this.Image = false
        },
        onDecode(result) {
            this.data = result
            this.$emit("barcode", result)
        },
        onLoaded(result) {
            this.data = "upload : " + result
        },
        onError(result) {
            this.data = "error"
        },
    },
    data() {
        return {
            fab: false,
            data: null,
            Stream: false,
            Image: false,
        }
    },
}
</script>
<style scoped>
.v-speed-dial {
    position: absolute !important;
}

.v-btn--floating {
    position: relative !important;
}
</style>
